import { integrationSchemaRegistry } from '@main/shared/utils';
import z from 'zod/v4';

export enum AzureDatabaseType {
  SQLServer = 'azure.sql-server',
  SQLManagedInstance = 'azure.sql-managed-instance',
  MySQLFlexible = 'azure.mysql-flexible',
  PostgreSQLFlexible = 'azure.postgresql-flexible',
  ElasticPool = 'azure.elastic-pool',
}

const dbSelectorCommonSchema = z
  .object({
    type: z
      .enum([
        AzureDatabaseType.MySQLFlexible,
        AzureDatabaseType.PostgreSQLFlexible,
        AzureDatabaseType.SQLManagedInstance,
        AzureDatabaseType.SQLServer,
      ])
      .register(integrationSchemaRegistry, {
        i18n: 'integrations.azure.services.sql.shared.db_type',
      }),
    resourceGroup: z.string().min(1),
    name: z.string().min(1),
  })
  .register(integrationSchemaRegistry, {
    i18n: 'integrations.azure.services.sql.shared.db_selector.common',
  });

const dbSelectorElasticPoolSchema = z
  .object({
    type: z.literal(AzureDatabaseType.ElasticPool).register(integrationSchemaRegistry, {
      i18n: 'integrations.azure.services.sql.shared.db_type',
    }),
    resourceGroup: z.string().min(1),
    name: z.string().min(1),
    elasticPoolName: z.string().min(1),
  })
  .register(integrationSchemaRegistry, {
    i18n: 'integrations.azure.services.sql.shared.db_selector.azure.elastic-pool',
  });

export const dbSelectorSchema = z.discriminatedUnion('type', [
  dbSelectorCommonSchema,
  dbSelectorElasticPoolSchema,
]);

export type AzureDatabaseCommonSelector = z.infer<typeof dbSelectorCommonSchema>;
export type AzureDatabaseElasticPoolSelector = z.infer<typeof dbSelectorElasticPoolSchema>;
export type AzureDatabaseSelector = z.infer<typeof dbSelectorSchema>;
